import { render } from "./TransactionUser.vue?vue&type=template&id=b37c8ffe&scoped=true"
import script from "./TransactionUser.vue?vue&type=script&lang=js"
export * from "./TransactionUser.vue?vue&type=script&lang=js"

import "./TransactionUser.vue?vue&type=style&index=0&id=b37c8ffe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37c8ffe"]])

export default __exports__